export default __webpack_public_path__ + "static/media/Layer_1@2x.c9adf4d1.png";